const ButtonLoader = () => {
  return (
    <span
      className='ml-2 spinner-border spinner-border-sm btn-spinner'
      role='status'
      aria-hidden='true'
    ></span>
  );
};

export default ButtonLoader;
